export const accordionTokens = {
  accordion: {
    panel: {
      borderWidth: '0',
      borderColor: '{surface.300}'
    },
    header: {
      padding: '1rem',
      background: '{surface.100}',
      borderWidth: '0',
      borderColor: '{surface.300}',
      color: '{text.color}',
      borderRadius: '{borderRadius.sm}',
      fontWeight: '500',
      first: {
        borderWidth: '0',
        topBorderRadius: '{borderRadius.sm}'
      },
      last: {
        bottomBorderRadius: '{borderRadius.sm}',
        activeBottomBorderRadius: '0'
      },
      toggleIcon: {
        color: '{primary.color}',
        hoverColor: '{primary.color}',
        activeColor: '{primary.color}',
        activeHoverColor: '{primary.color}'
      },
      focusRing: {
        width: '0',
        style: 'none',
        color: 'transparent',
        offset: '0',
        shadow: 'none'
      },
      hoverBackground: '{surface.200}',
      hoverColor: '{text.color}',
      activeBackground: '{surface.0}',
      activeColor: '{text.color}',
      activeHoverBackground: '{surface.0}',
      activeHoverColor: '{text.color}'
    },
    content: {
      padding: '1rem',
      borderWidth: '0',
      borderColor: '{surface.300}',
      background: '{surface.0}',
      color: '{text.color}'
    },
    transitionDuration: '{transition.duration}'
  }
};

export type AccordionTokens = typeof accordionTokens;
